import { createAsyncThunk } from "@reduxjs/toolkit";

import { MessageResponse } from "../../../api/common";
import SanctionEventsAPI, {
    GetSanctionEventsResponse,
    UpsertSanctionEventsParams,
} from "../../../api/sanctionEvents";
import { RootState } from "../../../app/store";

export const fetchSanctionEvents = createAsyncThunk<
    GetSanctionEventsResponse,
    string,
    {
      state: RootState & {
        sanctionEvents?: {
          caseId?: string;
          status?: string;
        };
      };
      rejectValue: string;
    }
>(
    "sanctionEvents/fetchSanctionEvents",
    async (caseId, { rejectWithValue }) => {
      try {
        return await SanctionEventsAPI.getSanctionEvents({ case_id: caseId });
      } catch {
        return rejectWithValue("Failed to fetch sanction events");
      }
    },
    {
      condition(caseId, { getState }) {
        const state = getState().sanctionEvents;
        if (!state) return true;

        return !(
          state.caseId === caseId &&
          (state.status === "loading" || state.status === "success")
        );
      },
    },
);

export const upsertSanctionEvents = createAsyncThunk<
    MessageResponse,
    UpsertSanctionEventsParams,
    { rejectValue: string }
>(
    "sanctionEvents/upsertSanctionEvents",
    async (params, { rejectWithValue }) => {
      try {
        return await SanctionEventsAPI.upsertSanctionEvents(params);
      } catch {
        return rejectWithValue("Failed to save sanction events");
      }
    },
);
